import styled from 'styled-components';
import { Row, Tooltip } from 'antd';

export const FaCardWrapper = styled.div`
  display: inline-block;
  padding: 0;
  width: 33.33%;
  height: 299px;
  padding-right: 20px;
  margin-bottom: 20px;
  ${({ Long }) =>
    Long &&
    `
  height: 775px;
  `}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 20px;
    width: calc(100% - 40px);
    padding-right: 0;
  }
  @media screen and (max-width: 374px) {
    height: 270px;
    ${({ Long }) =>
      Long &&
      `
       height: 761px;
    `}
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    width: 50%;
  }
`;

export const HeadContent = styled.h3`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h3};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.headingColor};
  font-style: normal;
  font-stretch: normal;
  margin: 0px;
  padding-bottom: 15px;
  & > span:first-of-type {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
    width: ${props => (props.text.length >= 21 ? '90%' : '')};
    vertical-align: text-top;
    @media only screen and (min-width: 320px) and (max-width: 425px) {
      font-size: ${props => props.theme.fontSize.h4};
    }
    @media only screen and (min-width: 426px) and (max-width: 991px) {
      font-size: 1.4rem;
    }
  }
`;

export const FundNameContent = styled.p`
  /* added for ellipsis */
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  /* ellipsis */
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing: 0px;
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.thead};
  font-style: normal;
  font-stretch: normal;
  margin: 0;
  padding-bottom: ${props => (props.noPadding ? '0' : '20px')};
  ${({ smallFont }) =>
    smallFont &&
    `
  line-height: 1.5;
  font-size: ${props => props.theme.fontSize.tertiary};
  padding-bottom: ${props => (props.noPadding ? '0' : '20px')};
  `}
`;

export const LastOn = styled(FundNameContent)`
   font-size: ${props => props.noPadding ? props.theme.fontSize.secondary : props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.noPadding ? props.theme.fontSize.tertiary : props.theme.fontSize.secondary};
  }
`;

export const BalanceWrapper = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: 24px;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.headingColor};
  font-style: normal;
  font-stretch: normal;
  margin: 0;
  padding-bottom: 5px;
  ${({ RightPadding }) =>
    RightPadding &&
    `
    padding-bottom: 0px;
    padding-right: 19px;
    border-right:1px solid #d4d4d4;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      border: none;
      font-size: 20px;
    }
  `}
  ${({ BottomPadding }) =>
    BottomPadding &&
    `
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding-bottom: 19px;
    }
    `}
    @media only screen and (min-width: 320px) and (max-width: 425px) {
     font-size: ${props => props.theme.fontSize.h5};
    }

  @media only screen and (min-width: 426px) and (max-width: 991px) {
    font-size: ${props =>
      props.currentBalance
        ? props => props.theme.fontSize.h5
        : props.theme.fontSize.heading};
  }
`;
export const DollarValue = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  font-size: ${props =>
    props.smallFont ? props.theme.fontSize.h4 : props.theme.fontSize.h3};
  color: ${props => props.theme.fontColors.green};
  line-height: normal;
  letter-spacing: normal;
  margin: 0;
  padding-bottom: ${props => props.currentBalance ? '20px' : '0'};
  ${({ smallFont }) =>
    smallFont &&
    `
padding-bottom: 10px;
`}
  ${({ Underlined, currentBalance }) =>
    Underlined && currentBalance &&
    `
border-bottom: 1px solid #d4d4d4;
`}
  @media only screen and (max-width: 370px) {
    font-size: 1.6rem;
  }
`;

export const InvestmentWrapper = styled.div`
  padding: 0px 0px 20px 0px;
  height: 72px;
  @media only screen and (min-width: 426px) and (max-width: 991px) {
    height: 90px;
  }
`;
export const FlexWrapper = styled.div`
  display: flex;
  & > h5 {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    color: ${props => props.theme.fontColors.headingColor};
    font-size: ${props => props.theme.fontSize.primary};
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    line-height: ${props => props.theme.lineHeight.tableFont};
    font-style: normal;
    font-stretch: normal;
    margin: 0;
    padding-right: 10px;
    width: 21%;
    @media only screen and (max-width: 375px) {
      font-size: ${props => props.theme.fontSize.secondary};
      width: 24%;
    }
    @media only screen and (min-width: 426px) and (max-width: 991px) {
      padding-right: 70px;
    }
  }
  > p {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.thead};
    font-size: ${props => props.theme.fontSize.primary};
    font-style: normal;
    font-stretch: normal;
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: normal;
    margin: 0;
    @media only screen and (max-width: 375px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
`;

export const Wrapper = styled.div`
  height: 250px;
  padding: 20px 20px;
  background: ${props => props.theme.backgroundColor.layoutLight};
  box-shadow: 0 9px 21px 0 rgba(128, 152, 213, 0.08);
  ${({ Long }) =>
    Long &&
    `
    height: 735px;
  `}
  @media only screen and (max-width: 320px) {
    height: 220px;
    ${({ Long }) =>
      Long &&
      `
    // height: 582px;
    height: 722px;
  `}
  }
  @media only screen and (min-width: 425px) and (max-width: 991px) {
    padding: 20px 16px;
  }
`;

export const HR = styled.hr`
  color: filledTabsInactive;
  margin: 0;
`;

export const AllocationRow = styled(Row)`
  padding-top: 20px;
  ${({ BottomMargin }) =>
    BottomMargin &&
    `
    border-bottom: 1px solid #d4d4d4;
  `}
`;

export const WrapperCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
  @media only screen and (max-width: 720px) {
    margin: 0;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    > * {
      /* margin-left: 12px; */
    }
  }
  @media only screen and (min-width: 992px) and (max-width: 1024px) {
    > * {
      margin: 0 auto;
      margin-bottom: 20px;
      /* margin-left: 86px; */
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    & > div:last-child {
      margin-bottom: 0px;
    }
  }
`;

export const WrapperController = styled.span`
  position: relative;
  vertical-align: text-top;
`;

export const ProfileImage = styled.img`
  vertical-align: middle;
  padding: 0 5px;
  cursor: pointer;
  &:hover ~ div,
  &:hover > div {
    display: block;
  }
`;

export const Advisorwrapper = styled.div`
  display: none;
  padding: 12px 26px;
  background-color: rgba(0, 103, 120, 0.9) !important;
  position: absolute;
  color: white;
  left: 30px;
  width: 290px;
  top: -75%;
  z-index: 1;
  div {
    font-size: ${props => props.theme.fontSize.primary};
    font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
    p {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    }
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 798px) {
    top: 30px;
    left: unset;
    width: 230px;
  }
`;

export const Triangle = styled.div`
  display: none;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-right: 7px solid rgba(0, 103, 120, 0.9);
  border-bottom: 6px solid transparent;
  position: absolute;
  left: 23px;
  top: 6px;
  @media only screen and (min-width: 320px) and (max-width: 798px) {
    left: 40%;
    top: 21px;
    transform: rotate(90deg);
  }
`;

export const DollarController = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid #d4d4d4;
`;

export const TooltipContainer = styled(Tooltip)`
  position: relative;
  left: 0;
  display: inline-block;
`;